export const METADATA = {
  name: 'kitty-agent',
  version: '0.0.1',
};

export default METADATA;
